import { useState } from 'react'
import { NavLink, Link } from 'react-router-dom'
import { useScrolled } from '@/hooks/useScrolled'
import { NAV_LINKS } from '@/data/siteData'
import { NavInstallButton } from '@/components/InstallPWA/InstallPWA'
import styles from './Navbar.module.css'

export default function Navbar() {
  const scrolled = useScrolled()
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <header className={`${styles.navbar} ${scrolled ? styles.scrolled : ''}`} role="banner">
      <nav className={styles.inner} aria-label="Main navigation">
        {/* Logo */}
        <Link to="/" className={styles.logo} aria-label="NexusAIWeb Home">
          <img src="/nexusai-logo.png" alt="NexusAI" className={styles.logoImg} />
        </Link>

        {/* Desktop Nav */}
        <ul className={styles.links} role="list">
          {NAV_LINKS.map(({ href, label }) => (
            <li key={href}>
              <NavLink
                to={href}
                end={href === '/'}
                className={({ isActive }) =>
                  `${styles.link} ${isActive ? styles.linkActive : ''}`
                }
              >
                {label}
              </NavLink>
            </li>
          ))}
        </ul>

        {/* CTA */}
        <div className={styles.cta}>
          <NavInstallButton />
          <a
            href="https://pn.nexusaiweb.com/login"
            target="_blank"
            className="btn btn-ghost"
            rel="noopener noreferrer"
          >
            Sign In
          </a>
          <a
            href="https://pn.nexusaiweb.com/signup"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
          >
            Get Started
          </a>
        </div>

        {/* Mobile Toggle */}
        <button
          className={styles.mobileToggle}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
          aria-expanded={mobileOpen}
        >
          <span className={`${styles.hamburger} ${mobileOpen ? styles.open : ''}`} />
        </button>
      </nav>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className={styles.mobileMenu} role="dialog" aria-label="Mobile navigation">
          <ul role="list">
            {NAV_LINKS.map(({ href, label }) => (
              <li key={href}>
                <NavLink
                  to={href}
                  end={href === '/'}
                  className={({ isActive }) =>
                    `${styles.mobileLink} ${isActive ? styles.mobileLinkActive : ''}`
                  }
                  onClick={() => setMobileOpen(false)}
                >
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>
          <div className={styles.mobileCta}>
            <a href="https://pn.nexusaiweb.com/login" target="_blank" rel="noopener noreferrer" className="btn btn-ghost" style={{ width: '100%', justifyContent: 'center' }}>
              Sign In
            </a>
            <a href="https://pn.nexusaiweb.com/signup" target="_blank" rel="noopener noreferrer" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }}>
              Get Started Free
            </a>
          </div>
        </div>
      )}
    </header>
  )
}
